import { Link } from 'react-router-dom';

function NotFound() {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '60vh',
      padding: '2rem',
      textAlign: 'center',
    }}>
      <h1 style={{ fontSize: '3rem', fontWeight: 700, color: '#1a1a2e', marginBottom: '0.5rem' }}>
        404
      </h1>
      <h2 style={{ fontSize: '1.5rem', color: '#333', marginBottom: '0.75rem' }}>
        Page Not Found
      </h2>
      <p style={{ color: '#666', marginBottom: '1.5rem', maxWidth: '420px' }}>
        The page you're looking for doesn't exist or has been moved.
      </p>
      <Link
        to="/"
        style={{
          padding: '0.625rem 1.25rem',
          borderRadius: '6px',
          background: '#2563eb',
          color: '#fff',
          textDecoration: 'none',
          fontSize: '0.95rem',
        }}
      >
        Return Home
      </Link>
    </div>
  );
}

export default NotFound;
